import * as fromDatatype from '../datatype-library/index';

export interface bl_ppl_from_peppol_generic_doc_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  process_type: fromDatatype.VarcharDatatypeInterface;
  generic_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
  einvoice_shipping_entity_json: any;
  trade_customs_ref_no: fromDatatype.VarcharDatatypeInterface;
  trade_incoterms: fromDatatype.VarcharDatatypeInterface;
  trade_agreement: fromDatatype.VarcharDatatypeInterface;
  trade_authorization_number: fromDatatype.VarcharDatatypeInterface;
  trade_custom_ref_no_2: fromDatatype.VarcharDatatypeInterface;
  trade_other_charges_desc: fromDatatype.VarcharDatatypeInterface;
  einvoice_delivery_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  gendoc_hdr_server_doc_type: fromDatatype.VarcharDatatypeInterface;
  irb_digital_signature: fromDatatype.VarcharDatatypeInterface;
  supplier_name: fromDatatype.VarcharDatatypeInterface;
  buyer_name: fromDatatype.VarcharDatatypeInterface;
  supplier_tax_id: fromDatatype.VarcharDatatypeInterface;
  supplier_id_no: fromDatatype.VarcharDatatypeInterface;
  supplier_sales_service_tax_id: fromDatatype.VarcharDatatypeInterface;
  supplier_email: fromDatatype.VarcharDatatypeInterface;
  supplier_standard_indu_class_code: fromDatatype.VarcharDatatypeInterface;
  supplier_business_activity_desc: fromDatatype.VarcharDatatypeInterface;
  buyer_tax_id: fromDatatype.VarcharDatatypeInterface;
  buyer_id_no: fromDatatype.VarcharDatatypeInterface;
  buyer_sales_service_tax_id: fromDatatype.VarcharDatatypeInterface;
  supplier_tourism_tax_id: fromDatatype.VarcharDatatypeInterface;
  buyer_email: fromDatatype.VarcharDatatypeInterface;
  supplier_address: fromDatatype.VarcharDatatypeInterface;
  buyer_address: fromDatatype.VarcharDatatypeInterface;
  supplier_contact_no: fromDatatype.VarcharDatatypeInterface;
  buyer_contact_no: fromDatatype.VarcharDatatypeInterface;
  einvoice_ver: fromDatatype.VarcharDatatypeInterface;
  einvoice_type: fromDatatype.VarcharDatatypeInterface;
  einvoice_code_no: fromDatatype.VarcharDatatypeInterface;
  original_einvoice_ref_no: fromDatatype.VarcharDatatypeInterface;
  einvoice_datetime: fromDatatype.TimestampTzDatatypeInterface;
  validation_datetime: fromDatatype.TimestampTzDatatypeInterface;
  supplier_digital_signature: fromDatatype.VarcharDatatypeInterface;
  invoice_currency_code: fromDatatype.VarcharDatatypeInterface;
  currency_rate: fromDatatype.NumericDatatypeInterface;
  billing_frequency: fromDatatype.VarcharDatatypeInterface;
  billing_period: fromDatatype.VarcharDatatypeInterface;
  irb_doc_unique_ref_no: fromDatatype.VarcharDatatypeInterface;
  tax_exemption_amount: fromDatatype.NumericDatatypeInterface;
  sub_total: fromDatatype.NumericDatatypeInterface;
  total_exclude_tax: fromDatatype.NumericDatatypeInterface;
  total_include_tax: fromDatatype.NumericDatatypeInterface;
  submission_status: fromDatatype.NumericDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  posting_status: fromDatatype.VarcharDatatypeInterface;
  generic_doc_hdr_server_doc_type: fromDatatype.VarcharDatatypeInterface;
  actual_submission_date: fromDatatype.TimestampTzDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  einvoice_supplier_company_guid: fromDatatype.GuidDataFieldInterface;
  einvoice_supplier_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  einvoice_buyer_company_guid: fromDatatype.GuidDataFieldInterface;
  einvoice_buyer_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
}

export class bl_ppl_from_peppol_generic_doc_hdr_RowClass
  implements bl_ppl_from_peppol_generic_doc_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    process_type: fromDatatype.VarcharDatatypeInterface;
    generic_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
    einvoice_shipping_entity_json: any;
    trade_customs_ref_no: fromDatatype.VarcharDatatypeInterface;
    trade_incoterms: fromDatatype.VarcharDatatypeInterface;
    trade_agreement: fromDatatype.VarcharDatatypeInterface;
    trade_authorization_number: fromDatatype.VarcharDatatypeInterface;
    trade_custom_ref_no_2: fromDatatype.VarcharDatatypeInterface;
    trade_other_charges_desc: fromDatatype.VarcharDatatypeInterface;
    einvoice_delivery_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
    gendoc_hdr_server_doc_type: fromDatatype.VarcharDatatypeInterface;
    irb_digital_signature: fromDatatype.VarcharDatatypeInterface;
    supplier_name: fromDatatype.VarcharDatatypeInterface;
    buyer_name: fromDatatype.VarcharDatatypeInterface;
    supplier_tax_id: fromDatatype.VarcharDatatypeInterface;
    supplier_id_no: fromDatatype.VarcharDatatypeInterface;
    supplier_sales_service_tax_id: fromDatatype.VarcharDatatypeInterface;
    supplier_email: fromDatatype.VarcharDatatypeInterface;
    supplier_standard_indu_class_code: fromDatatype.VarcharDatatypeInterface;
    supplier_business_activity_desc: fromDatatype.VarcharDatatypeInterface;
    buyer_tax_id: fromDatatype.VarcharDatatypeInterface;
    buyer_id_no: fromDatatype.VarcharDatatypeInterface;
    buyer_sales_service_tax_id: fromDatatype.VarcharDatatypeInterface;
    supplier_tourism_tax_id: fromDatatype.VarcharDatatypeInterface;
    buyer_email: fromDatatype.VarcharDatatypeInterface;
    supplier_address: fromDatatype.VarcharDatatypeInterface;
    buyer_address: fromDatatype.VarcharDatatypeInterface;
    supplier_contact_no: fromDatatype.VarcharDatatypeInterface;
    buyer_contact_no: fromDatatype.VarcharDatatypeInterface;
    einvoice_ver: fromDatatype.VarcharDatatypeInterface;
    einvoice_type: fromDatatype.VarcharDatatypeInterface;
    einvoice_code_no: fromDatatype.VarcharDatatypeInterface;
    original_einvoice_ref_no: fromDatatype.VarcharDatatypeInterface;
    einvoice_datetime: fromDatatype.TimestampTzDatatypeInterface;
    validation_datetime: fromDatatype.TimestampTzDatatypeInterface;
    supplier_digital_signature: fromDatatype.VarcharDatatypeInterface;
    invoice_currency_code: fromDatatype.VarcharDatatypeInterface;
    currency_rate: fromDatatype.NumericDatatypeInterface;
    billing_frequency: fromDatatype.VarcharDatatypeInterface;
    billing_period: fromDatatype.VarcharDatatypeInterface;
    irb_doc_unique_ref_no: fromDatatype.VarcharDatatypeInterface;
    tax_exemption_amount: fromDatatype.NumericDatatypeInterface;
    sub_total: fromDatatype.NumericDatatypeInterface;
    total_exclude_tax: fromDatatype.NumericDatatypeInterface;
    total_include_tax: fromDatatype.NumericDatatypeInterface;
    submission_status: fromDatatype.NumericDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    posting_status: fromDatatype.VarcharDatatypeInterface;
    generic_doc_hdr_server_doc_type: fromDatatype.VarcharDatatypeInterface;
    actual_submission_date: fromDatatype.TimestampTzDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    einvoice_supplier_company_guid: fromDatatype.GuidDataFieldInterface;
    einvoice_supplier_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
    einvoice_buyer_company_guid: fromDatatype.GuidDataFieldInterface;
    einvoice_buyer_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
}
